import styled from 'styled-components';
import cssKit from '../../css';

const nissan = process.env.BRAND_NAME === 'nissan';

export const ButtonStyled = styled.button`
  width: ${props => props.width};
  float: ${props => props.float};
  background-color: ${nissan ? '#c51a47' : '#fff'};
  text-transform: uppercase;
  font-family: ${cssKit.fonts.bold};
  font-size: .9rem;
  font-weight: 700;
  /* display: inline-block; */
  cursor: pointer;
  -webkit-appearance: none;
  -webkit-transition: background-color .25s ease-out,color .25s ease-out;
  transition: background-color .25s ease-out,color .25s ease-out;
  border: ${nissan ? '1px solid transparent' : '1px solid #000'};
  border-radius: 0;
  padding: ${nissan ? '.85em 1em' : '.85em 2em'};
  margin: 0 0 1rem;
  color: ${nissan ? '#fff' : '#000'};

  ${cssKit.media.greaterThan('small') `
    padding: ${nissan ? '.85em 1em' : '.85em 4em'};
  `};

  &:after{
      position: relative;
      content: '';
      width: .45rem;
      height: .45rem;
      display: inline-block;
      background: 0 0;
      border-top: solid 2px #fff;
      border-left: solid 2px #fff;
      -webkit-transform: rotate(45deg) translate(-50%);
      -ms-transform: rotate(45deg) translate(-50%);
      transform: rotate(135deg) translate(-50%);
      pointer-events: none;
      left: 0;
      top: 5px;
      padding: 0;
      margin: 0;
      float: right;
    }
`;



/** WEBPACK FOOTER **
 ** ./src/components/Button/styles.js
 **/